import { tv } from '~/utils/tv'

export const listStyles = tv({
  slots: {
    root: [
      'relative min-w-64 flex-1 space-y-[var(--spacing-stack-twopulse)] bg-[var(--color-container-fill-default)] p-[var(--padding-inset-fourpulse)] outline-none',
    ],
    header: 'flex items-center gap-x-2',
    title:
      'line-clamp-2 font-bold text-[length:var(--font-size-threeandhalfpulse)] text-[var(--color-text-neutral-default)] leading-[var(--line-height-small)]',
    description:
      'line-clamp-4 font-normal text-[length:var(--font-size-threeandhalfpulse)] text-[var(--color-text-neutral-alternative)] leading-[var(--line-height-small)]',
    separator:
      "before:absolute before:bottom-0 before:h-px before:w-[calc(100%_-_2rem)] before:bg-[var(--color-fill-neutral-fallback)] before:content-['']",
  },
  variants: {
    isDisabled: {
      true: {
        root: 'cursor-not-allowed *:select-none',
        title: 'text-[var(--color-text-neutral-disabled)]',
        description: 'text-[var(--color-text-neutral-disabled)]',
      },
      false: {
        root: ['active:bg-[var(--color-container-fill-pressed)]'],
      },
    },
  },
})
